import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  //   CustomRule,
  Editing,
  FilterRow,
  Form,
  HeaderFilter,
  LoadPanel,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  StateStoring,
  Texts,
  Toolbar,
} from "devextreme-react/data-grid";
import {
  CustomRule,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import { Item } from "devextreme-react/toolbar";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getDateString } from "../common/date";

export default function AssignedRoles() {
  const [dataSource, setDataSource] = useState(null);
  const [roleDataSource, setRoleDataSource] = useState(null);

  const [present, setPresent] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  const assignedGridRef = useRef(null);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/assignedRoles/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/assignedRoles/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/assignedRoles/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/assignedRoles/${userInfo.employeeNo}/${key}`
          );
        },
      })
    );

    axios
      .get(`${process.env.REACT_APP_BECCO_API_URL}/api/cv/assignedRoles/role`)
      .then((result) => {
        setRoleDataSource(
          new DataSource({
            store: {
              data: result.data,
              type: "array",
              key: "role",
            },
          })
        );
      });
  }, []);

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;
      return;
    }

    const newRole = {
      //   name: args.text,
      role: args.text,
    };

    args.customItem = roleDataSource
      .store()
      .insert(newRole)
      .then(() => roleDataSource.load())
      .then(() => newRole)
      .catch((error) => {
        throw error;
      });
  };

  const calculateDisplayValue = (data) => {
    return `${getDateString(new Date(data.startDate))}~${
      data.ps == 1 ? "Present" : getDateString(new Date(data.endDate))
    }`;
  };

  const onInitNewRow = (e) => {
    e.data.ps = false;
  };

  //   const onEditingStart = (e) => {
  //     console.debug("[onEditingStart]");

  //     axios
  //       .get(`${process.env.REACT_APP_BECCO_API_URL}/api/cv/assignedRoles/role`)
  //       .then((result) => {
  //         console.debug("[result]", result.data);

  //         setRoleDataSource(
  //           new DataSource({
  //             store: result.data,
  //             type: "array",
  //             key: "role",
  //           })
  //         );
  //       });
  //   };

  //   const onValueChanged = (e) => {
  //     setPresent(e.component.option("value"));
  //   };

  const customizeItem = (item) => {
    if (item) {
      let gridInstance = assignedGridRef.current.instance;
      let editRowKey = gridInstance.option("editing.editRowKey");
      let index = gridInstance.getRowIndexByKey(editRowKey);
      index = index === -1 ? 0 : index;

      if (item.dataField == "endDate") {
        if (gridInstance.cellValue(index, "ps") == true) {
          item.disabled = true;
        }
      } else if (item.dataField == "ps") {
        if (gridInstance.cellValue(index, "endDate")) {
          item.disabled = true;
        }
      }
    }
  };

  const setCellValue = (newData, value) => {
    newData.ps = value;
  };

  const setEndDateCellValue = (newData, value) => {
    newData.endDate = value;
  };

  return (
    <React.Fragment>
      <DataGrid
        id="assignedGrid"
        ref={assignedGridRef}
        dataSource={dataSource}
        keyExpr="SEQ"
        rowAlternationEnabled={true}
        showBorders={true}
        showColumnLines={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        allowColumnReordering={true}
        style={{
          maxHeight: "calc(100vh - 180px)",
          marginLeft: "10px",
          marginRight: "10px",
          // marginTop: "56px",
        }}
        hoverStateEnabled={true}
        showColumnHeaders={false}
        onInitNewRow={onInitNewRow}
      >
        <LoadPanel enabled={true} />

        {/* <FilterRow visible={true} /> */}
        {/* <HeaderFilter visible={true} /> */}

        <SearchPanel visible={true} />

        <Scrolling mode={"virtual"} showScrollbar={"always"} />

        <Selection mode={"single"} />

        <Editing
          mode={"popup"}
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
        >
          <Texts
            confirmDeleteTitle={"Delete the Role"}
            confirmDeleteMessage={"Are you sure you want to delete this role?"}
          />

          <Popup title={"Assigned Role"} showTitle="true" height={200} />
          <Form
            labelMode={"outside"}
            showColonAfterLabel={false}
            labelLocation="top"
            minColWidth={300}
            colCount={2}
            colCountByScreen={{ sm: 2, md: 4 }}
            screenByWidth={(width) => {
              return width < 720 ? "sm" : "md";
            }}
            validationGroup="assignedRole"
            height={"100%"}
            customizeItem={customizeItem}
          >
            <SimpleItem
              dataField={"startDate"}
              editorType="dxDateBox"
              editorOptions={{
                type: "date",
                displayFormat: "yyyy-MM-dd",
                dateSerializationFormat: "yyyy-MM-dd",
                showClearButton: true,
                max: new Date(),
              }}
            >
              <Label text={"Start Date"} />
              <RequiredRule message={"* Start Date를 입력해주세요."} />
            </SimpleItem>
            <SimpleItem
              dataField={"endDate"}
              editorType="dxDateBox"
              editorOptions={{
                type: "date",
                displayFormat: "yyyy-MM-dd",
                dateSerializationFormat: "yyyy-MM-dd",
                showClearButton: true,
                max: new Date(),
                disabled: present == true ? true : false,
              }}
            >
              <Label text={"End date"} />
              {/* <CustomRule validationCallback={validationCallback} /> */}
            </SimpleItem>
            <SimpleItem
              dataField={"ps"}
              editorType="dxCheckBox"
              editorOptions={{
                text: "Present",
                // defaultValue: false,
                // onValueChanged: onValueChanged,
              }}
            >
              <Label visible={false} />
            </SimpleItem>
            <SimpleItem
              dataField={"role"}
              editorType="dxSelectBox"
              editorOptions={{
                showClearButton: true,
                dataSource: roleDataSource,
                displayExpr: "role",
                valueExpr: "role",
                acceptCustomValue: true,
                onCustomItemCreating: onCustomItemCreating,
              }}
            >
              <Label text={"Role"} />
              <RequiredRule message={"* Role을 입력해주세요."} />
            </SimpleItem>
          </Form>
        </Editing>

        {/* <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={"CurriculumVitae.AssignedRolesDataGrid"}
        /> */}

        <Column
          dataField="startDate"
          caption="Start Date"
          dataType="date"
          format="yyyy-MM-dd"
          editorOptions={{
            dateSerializationFormat: "yyyy-MM-dd",
          }}
          visible={false}
        />
        <Column
          dataField="endDate"
          caption="End Date"
          dataType="date"
          format="yyyy-MM-dd"
          editorOptions={{
            dateSerializationFormat: "yyyy-MM-dd",
          }}
          visible={false}
          setCellValue={setEndDateCellValue}
        />
        <Column
          dataField={"ps"}
          caption="Present"
          dataType={"string"}
          visible={false}
          setCellValue={setCellValue}
        />
        <Column
          dataField={"duration"}
          caption="Duration"
          dataType={"string"}
          calculateDisplayValue={calculateDisplayValue}
          width={200}
        />
        <Column dataField={"role"} caption="Role" dataType={"string"} />

        <Toolbar>
          <Item location="before">
            <span
              style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
            >
              ASSIGNED ROLES
            </span>
          </Item>
          <Item location="after" name="addRowButton" />
          <Item location="after" name="searchPanel" />
        </Toolbar>
      </DataGrid>
    </React.Fragment>
  );
}
